export default "__VITE_ASSET__QvctLc2x__"